import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addUserToGroups } from '../api/USERS/users';
import { toast } from 'react-toastify';

export const useAddUserToGroups = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, groupIds }) => addUserToGroups(userId, groupIds),
    onSuccess: (data, variables) => {
      // Invalider le cache pour recharger les données de l'utilisateur
      queryClient.invalidateQueries({ queryKey: ['user', variables.userId] });
      queryClient.invalidateQueries({ queryKey: ['users'] });
      toast.success('Utilisateur ajouté au groupe avec succès');
    },
    onError: (error) => {
      toast.error(error.message || 'Erreur lors de l\'ajout au groupe');
    }
  });
};
